const GOOGLE_SHEET_WEB_APP_URL = process.env.REACT_APP_GOOGLE_SHEET_WEB_APP_URL;
const GOOGLE_SHEET_DEPLOYMENT_ID = process.env.REACT_APP_GOOGLE_SHEET_DEPLOYMENT_ID;

const cleanEnvValue = (value) => (value || "").trim().replace(/^["']|["']$/g, "");

const getGoogleSheetUrl = () => {
    const webAppUrl = cleanEnvValue(GOOGLE_SHEET_WEB_APP_URL);
    const deploymentId = cleanEnvValue(GOOGLE_SHEET_DEPLOYMENT_ID);

    if (webAppUrl) {
        return webAppUrl;
    }

    if (deploymentId) {
        return `https://script.google.com/macros/s/${deploymentId}/exec`;
    }

    return "";
};

const formatSheetTimestamp = (date) => {
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    }).formatToParts(date);

    const value = (type) => parts.find((part) => part.type === type)?.value || "";

    return `${value("day")}-${value("month")}-${value("year")} ${value("hour")}:${value("minute")} ${value("dayPeriod").toUpperCase()}`;
};

export const submitLead = async ({ name, mobile, course }) => {
    const googleSheetUrl = getGoogleSheetUrl();

    if (!googleSheetUrl) {
        throw new Error("Google Sheet Web App URL is not configured.");
    }

    const submittedAt = formatSheetTimestamp(new Date());
    const payload = new URLSearchParams({
        "Time Stamp": submittedAt,
        "Full Name": name,
        Phone: mobile,
        Course: course,
        timestamp: submittedAt,
        name,
        fullName: name,
        mobile,
        phone: mobile,
        course,
        submittedAt,
    });

    await fetch(googleSheetUrl, {
        method: "POST",
        mode: "no-cors",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: payload,
    });

    return { success: true };
};
